import { Button } from './Button';

export function CajaCerradaBanner({ onAbrir }: { onAbrir: () => void }) {
  return (
    <div
      role="status"
      className="border-warning bg-warning-soft flex shrink-0 flex-wrap items-center justify-between gap-3 rounded-md border px-3 py-2"
    >
      <p className="text-sm text-neutral-900">
        <strong className="font-semibold">La caja está cerrada.</strong> No se puede cobrar hasta
        abrir el turno.
      </p>
      <Button type="button" variant="secondary" size="md" onClick={onAbrir}>
        Abrir caja
      </Button>
    </div>
  );
}
